import type { ApiClient } from '@travel/api-client';
import type { SearchEngine } from 'SearchEngine-Types';
import { MONTEROSA_API_TIMEOUT } from 'store/utils';

import type { SearchAreasResponse } from 'SearchAreas-Types';
export const fetch = (
  http: ApiClient,
  departureArea?: string,
  accommodationArea?: string,
  searchEngine?: SearchEngine,
): Promise<SearchAreasResponse> =>
  http.post('/monterosa-api-dp/dp/jrdp/v2/areas', {
    ignoreCommonErrorHandler: true,
    values: {
      departureArea,
      accommodationArea,
      searchEngine,
    },
    timeout: MONTEROSA_API_TIMEOUT,
  });
